import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import '../../../../styles/AdminDashboardPage.css';

interface TourByMonth {
    month: string;
    count: number;
}

interface Props {
    tourByMonth: TourByMonth[];
}

export const ToursByMonth = ({ tourByMonth }: Props) => {
    const [stepSize, setStepSize] = useState(60);

    useEffect(() => {
        if (tourByMonth !== undefined) {
            // Calculate maximum count
            const maxCount = Math.max(...tourByMonth.map((t: TourByMonth) => t.count));

            // Calculate step size (one-fifth of maximum count)
            const calculatedStepSize = Math.ceil(maxCount / 5);

            // Set step size
            setStepSize(calculatedStepSize);
        }
    }, [tourByMonth]);

    const combinedTourByMonth = tourByMonth.reduce((acc: TourByMonth[], current) => {
        const existing = acc.find(item => item.month === current.month);
        if (existing) {
            existing.count += current.count;
        } else {
            acc.push(current);
        }
        return acc;
    }, []);

    return (
        <div className='bordered-card-layout'>
            <p className='dashboard-heading'>Total Tours by Month</p>
            <div style={{ width: '70vw' }}>
                {combinedTourByMonth && (
                    <Line
                        data={{
                            labels: combinedTourByMonth.map((t: TourByMonth) => t.month.substr(0, 3)),
                            datasets: [
                                {
                                    data: combinedTourByMonth.map((t: TourByMonth) => t.count),
                                    pointBorderColor: '#28A7de',
                                    pointBackgroundColor: '#28a7de',
                                    backgroundColor: '#FFFFFF00',
                                    borderColor: '#28A7de',
                                    borderWidth: 2,
                                    pointRadius: 2
                                }
                            ]
                        }}
                        options={{
                            scales: {
                                yAxes: [
                                    {
                                        ticks: {
                                            stepSize: stepSize,
                                            callback: function (value) {
                                                return value.toLocaleString('en-US');
                                            },
                                            min: 0
                                        },
                                        gridLines: {
                                            borderDash: [3, 3]
                                        }
                                    }
                                ],
                                xAxes: [
                                    {
                                        gridLines: {
                                            display: false
                                        }
                                    }
                                ]
                            },
                            legend: {
                                display: false
                            },
                            responsive: true,
                            layout: {
                                padding: {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                }
                            },
                            maintainAspectRatio: false
                        }}
                    />
                )}
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/pages/admin/analyticsDashboardWidgets/toursMonthCard.tsx